export default "__VITE_ASSET__DEEgOo6D__"